<template>
  <div>
    <h1>Wortfinder</h1>
    <p>Mit diesem Werkzeug kannst du Wörter suchen, die ein bestimmtes Muster beinhalten. Das Muster besteht aus mehreren Ziffern, wobei eine gleiche Ziffer für den gleichen Buchstaben steht. Das Muster <strong>„01223“</strong> trifft beispielsweise die Wörter <strong>„<span class="highlight">HALLO</span>“</strong> und <strong>„ABSCH<span class="highlight">LUSSP</span>RUEFUNG“</strong>. Sollte dein Muster mehr als 10 verschiedene Ziffern brauchen, kannst du auch Kleinbuchstaben verwenden.</p>
    <p>Das zugrundeliegende Wörterbuch entstand durch die Auswertung vieler Texte auf verschiedenen Nachrichtenseiten. Dadurch kann es vorkommen, dass auch ungewöhnliche „Wörter“ enthalten sind. Diese standen dann genau so auf einer Nachrichtenseite.</p>
    <WordFinder />
  </div>
</template>
<script>
import WordFinder from '@/components/WordFinder.vue'

export default {
  name: 'wordfinder',
  components: {
    WordFinder
  }
}
</script>
